import { render } from "./ReportMetricCalloutCard.vue?vue&type=template&id=0e35e0a3&scoped=true"
import script from "./ReportMetricCalloutCard.vue?vue&type=script&lang=js"
export * from "./ReportMetricCalloutCard.vue?vue&type=script&lang=js"

import "./ReportMetricCalloutCard.vue?vue&type=style&index=0&id=0e35e0a3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/etl/etl/outerspace-admin-2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e35e0a3"]])

export default __exports__